export default process.env.VUE_APP_CAMPAIGN_TYPE === 'BNN'
